import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

export function showCookiePreferences() {
  CookieConsent.showPreferences();
}

export function CookieConsentBanner() {
  useEffect(() => {
    void CookieConsent.run({
      // Start with revision 1 since we are introducing new analytics
      revision: 1,
      disablePageInteraction: false,
      guiOptions: {
        consentModal: {
          layout: 'bar',
          position: 'bottom',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {
          enabled: false,
        },
      },
      language: {
        default: 'nl',
        translations: {
          nl: {
            consentModal: {
              title: 'Cookievoorkeuren',
              description:
                'Wij gebruiken cookies om de website te laten functioneren en voor anonieme statistieken. U kunt uw voorkeuren hieronder aanpassen.',
              acceptAllBtn: 'Accepteren',
              // This button corresponds to "Weigeren" (Reject/Accept Necessary)
              acceptNecessaryBtn: 'Weigeren',
              showPreferencesBtn: 'Voorkeuren aanpassen',
            },
            preferencesModal: {
              title: 'Cookievoorkeuren',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles weigeren',
              savePreferencesBtn: 'Opslaan',
              closeIconLabel: 'Sluiten',
              sections: [
                {
                  title: 'Noodzakelijke cookies',
                  description: 'Deze cookies zijn essentieel voor de werking van de website en kunnen niet worden uitgeschakeld.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Statistieken (Analytics)',
                  description: 'Wij gebruiken first-party analytics om anoniem het gebruik van de website te meten. Dit helpt ons om de website te verbeteren.',
                  linkedCategory: 'analytics',
                },
                {
                  title: 'Meer informatie',
                  description: 'Voor meer details over hoe wij cookies en persoonsgegevens verwerken, zie ons <a href="/privacy">Privacybeleid</a> en <a href="/cookies">Cookiebeleid</a>.',
                },
              ],
            },
          },
        },
      },
    });
  }, []);

  return null;
}

export { CookieConsentBanner as CookieConsent };
export default CookieConsentBanner;
